import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import { ClearentPublicKeyResp, GetClearentPublicKeyForPayNowReq, MerchantAccount, Response } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class MerchantAccountService {
  private api: string = CONTROLLERS.PAYMENTS.MERCHANT_ACCOUNT;
  constructor(private apiService: ApiService) {}

  getById(customerId: number): Observable<Response<MerchantAccount>> {
    return this.apiService.getById(
      customerId.toString(),
      `${this.api}/${ENDPOINTS.PAYMENTS.MERCHANT_ACCOUNT.GET_BY_ID}`
    );
  }

  updateCustomer(
    updateReqCommand: MerchantAccount
  ): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PAYMENTS.MERCHANT_ACCOUNT.UPDATE}`,
      updateReqCommand
    );
  }

  getAllMerchantAccountByCustomerId(customerId: number | any): Observable<Response<MerchantAccount[]>> {
    return this.apiService.getById(
      customerId.toString(),
      `${this.api}/${ENDPOINTS.PAYMENTS.MERCHANT_ACCOUNT.GET_ALL_MERCHANT_ACCOUNT_BY_CUSTOMER_ID}`
    );
  }

  getByPracticeId(practiceId: number): Observable<Response<MerchantAccount>> {
    return this.apiService.getById(
      practiceId.toString(),
      `${this.api}/${ENDPOINTS.PAYMENTS.MERCHANT_ACCOUNT.GET_BY_PRACTICE_ID}`
    );
  }

  registerPayLinkWebhook(
    merchantAccountId: number,
    ownerType: number
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.MERCHANT_ACCOUNT.REGISTER_PAYLINK_WEBHOOK}`,
      { merchantAccountId, ownerType }
    );
  }

  getPracticeMerchantPublicKey(
    req : GetClearentPublicKeyForPayNowReq
  ): Observable<Response<ClearentPublicKeyResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PAYMENTS.MERCHANT_ACCOUNT.GET_PRACTICE_MERCHANT_PUBLIC_KEY}`,
     req
    );
  }
}
